import Vue from 'vue'

Vue.directive('loadmore', {
    bind(el, binding) {
      const tableWarper = el.querySelector('.el-table__body-wrapper')
      tableWarper.addEventListener('scroll', function() {
        let sign = 100
        const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
        //this.scrollTop大于0 向下滚动
        if (scrollDistance <= sign && this.scrollTop > 0) {
            binding.value()
        }
      })
    }
})



// WEBPACK FOOTER //
// ./static/js/lib/directive.js